import { TitularTooltip } from '@campfire/titular-tooltip';
import React, { memo } from 'react';
import { Star as StarIcon, DragIndicator } from '@material-ui/icons';
import { Box, Typography } from '@material-ui/core';
import { unpackToDate } from '@campfire/hot-date';

import { SupportResource } from '../__generated__/SupportResource';

interface ResourcesListItemProps {
  resource: SupportResource;
  borderBottom: boolean;
  showUploadDate: boolean;
  showDragHandle?: boolean;
}

const ResourcesListItem = memo((props: ResourcesListItemProps) => {
  const { resource, borderBottom, showUploadDate, showDragHandle } = props;
  return (
    <Box
      display='flex'
      alignItems='center'
      style={{
        padding: '14px 24px',
        borderBottom: borderBottom ? '1px solid #f5f5f5' : 'none',
        transition: 'background 0.1s',
        cursor: 'pointer',
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLElement).style.backgroundColor = '#fafafa';
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLElement).style.backgroundColor = 'transparent';
      }}
    >
      {/* Drag handle */}
      {showDragHandle ? (
        <Box display='flex' alignItems='center' style={{ color: '#ccc', cursor: 'grab', marginRight: 12 }}>
          <DragIndicator style={{ fontSize: 20 }} />
        </Box>
      ) : null}

      {/* Featured star */}
      <TitularTooltip
        placement='left'
        enterDelay={400}
        title='Featured Resource'
        description='Your team has indicated that this is an important item.'
      >
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          style={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            backgroundColor: resource.featured ? '#FFD700' : 'transparent',
            marginRight: 12,
            flexShrink: 0,
          }}
        >
          <StarIcon
            style={{
              fontSize: 14,
              color: resource.featured ? '#fff' : 'transparent',
            }}
          />
        </Box>
      </TitularTooltip>

      {/* Title and upload date */}
      <Box style={{ flex: 1, minWidth: 0 }}>
        <Typography
          noWrap
          style={{
            fontSize: 14,
            fontWeight: 500,
            color: '#333',
          }}
        >
          {resource.title}
        </Typography>
        {showUploadDate ? (
          <Typography
            noWrap
            style={{
              fontSize: 12,
              color: '#999',
              marginTop: 2,
            }}
          >
            {`Uploaded ${unpackToDate(resource.dateAdded).toFormat('dd MMM yyyy')}`}
          </Typography>
        ) : null}
      </Box>

      {/* Attachment count */}
      {resource.supportResourceAttachments.length >= 1 ? (
        <Typography
          style={{
            fontSize: 12,
            color: '#888',
            marginLeft: 16,
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}
        >
          {`${resource.supportResourceAttachments.length} ${
            resource.supportResourceAttachments.length > 1 ? 'Attachments' : 'Attachment'
          }`}
        </Typography>
      ) : null}
    </Box>
  );
});

export { ResourcesListItem };
